import React, { useContext, useState, useEffect } from "react";
import LoginInfoContext from "./Context/LoginInfoContext";
import { useHistory } from "react-router-dom";
import "./style/Login.css";
const Login = () => {
    const history = useHistory();
    const { roleData, loginCallback, sSystem, isHidden, getUrlDefault } = useContext(LoginInfoContext);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleLogin = () => {
        loginCallback({ acc: username, pwd: password });
    };

    useEffect(() => {
        history.push("/");

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let url = getUrlDefault(roleData);
        history.push(url);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sSystem.current, isHidden]);

    return (
        <div className="container login_container">
            <div className="login_block">
                <div className="login_top">
                    <img src="/img/big_logo.svg" alt="Logo" />
                </div>
                <div className="login_form">
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className="login_input"
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="login_input"
                    />
                    <button className="login_btn" onClick={handleLogin}>
                        <span>Login</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Login;
